import { fetchError, fetchStart, fetchSuccess, postSuccess } from './Common';
import {
  getTripsNewRequestApi,
  getTripsDetailsApi,
  getLoadsBetweenTwoCitiesApi,
  updateLoadInTripInterestLaneMapping,
  rejectTripInterest,
  bookBidRequestLoadApi,
} from 'redux/apis/trips';
import { editRequestsApi } from 'redux/apis/workbook';

export const TRIP_DETAILS_UPDATE = 'TRIP_DETAILS_UPDATE';
export const GET_TRIPS_NEW_REQUEST = 'GET_TRIPS_NEW_REQUEST';
export const getTripNewRequest = data => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getTripsNewRequestApi(data)
        .then(data => {
          dispatch({ type: GET_TRIPS_NEW_REQUEST, payload: data.data });
          dispatch(fetchSuccess());
          resolve(data.data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};

export const GET_TRIPS_STATUS = 'GET_TRIPS_STATUS';
export const getTripStatus = data => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getTripsNewRequestApi(data)
        .then(data => {
          dispatch({ type: GET_TRIPS_STATUS, payload: data.data });
          dispatch(fetchSuccess());
          resolve(data.data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};

export const rejectTrip = tripID => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      rejectTripInterest(tripID)
        .then(data => {
          dispatch(postSuccess('Trip Interests Rejected successfully.'));
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};

export const getTripDetails = tripId => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getTripsDetailsApi(tripId)
        .then(data => {
          dispatch({
            type: TRIP_DETAILS_UPDATE,
            payload: data.data,
          });
          dispatch(fetchSuccess());
          resolve(data.data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};

export const tripInterestBookLoadRequests = ({ data, loadId, type = 'book' }) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      bookBidRequestLoadApi(type, loadId, data)
        .then(async data => {
          dispatch(fetchSuccess());
          resolve(data.data);
        })
        .catch(async error => {
          if (error.response.status < 500) {
            dispatch(fetchError(error.response && error.response.data.error));
          } else {
            dispatch(fetchError('Booking was unsuccessful '));
          }
          reject(error);
        });
    });
  };
};

export const updateBookingLoadStatus = ({ data, booking_id }) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      editRequestsApi(booking_id, data)
        .then(async data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(async error => {
          dispatch(fetchError(error.response && error.response.data.error));
          reject(error);
        });
    });
  };
};

export const GET_LOADS_BETWEEN_CITY = 'GET_LOADS_BETWEEN_CITY';
export const getLoadBetweenCity = (queryData, laneIndex, isLoading = true) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      isLoading && dispatch(fetchStart());
      getLoadsBetweenTwoCitiesApi(queryData)
        .then(data => {
          dispatch({
            type: GET_LOADS_BETWEEN_CITY,
            payload: { laneIndex, data: data.data, start: queryData.start },
          });
          isLoading && dispatch(fetchSuccess());
          resolve(data.data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};

export const saveLoadsTripInterest = ({ trip_id, data, isLoading = true }) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      isLoading && dispatch(fetchStart());
      updateLoadInTripInterestLaneMapping(trip_id, data)
        .then(data => {
          isLoading && dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};
